$(document).ready(function () {
    // Fetch saved carts when the page loads
    fetchSavedCarts();

    // Select all checkboxes functionality
    $('#selectAllCarts').on('click', function () {
        var isChecked = $(this).prop('checked');
        $('.cartCheckbox').prop('checked', isChecked);
        toggleCartActions();
    });

    // Toggle cart actions based on checkbox selection
    $(document).on('change', '.cartCheckbox', function () {
        toggleCartActions();
    });

    // Handle combine carts button click
    $('#combineCartsBtn').on('click', function () {
        Swal.fire({
            title: 'Combine Carts',
            html: '<input type="text" id="combinedCartName" class="swal2-input" placeholder="Name for Combined Cart">',
            confirmButtonText: 'Save Combined Cart',
            focusConfirm: false,
            preConfirm: () => {
                const combinedCartName = Swal.getPopup().querySelector('#combinedCartName').value;
                if (!combinedCartName) {
                    Swal.showValidationMessage('Please provide a name for the combined cart.');
                }
                return combinedCartName;
            }
        }).then((result) => {
            if (result.isConfirmed) {
                const combinedCartName = result.value;
                var selectedCarts = $('.cartCheckbox:checked').map(function () {
                    return $(this).val();
                }).get();

                // Ensure combined cart name is unique
                var existingCartNames = $('.cartCheckbox').map(function () {
                    return $(this).data('cart-name');
                }).get();

                if (existingCartNames.includes(combinedCartName)) {
                    Swal.fire('Error', 'Cart name already exists. Please choose a different name.', 'error');
                    return;
                }

                $.ajax({
                    url: 'https://checkout.nalpac.com/quick-order/combineCarts?sales_rep_id=' + sales_rep_id + '&customer_id=' + customer_id + '&contact_id=' + contact_id + '&shopify_customer_id=' + shopify_customer_id + '&contact_name=' + contact_name + '&hmac=' + hmac,
                    method: 'POST',
                    data: {
                        cart_ids: selectedCarts,
                        combined_cart_name: combinedCartName
                    },
                    success: function (response) {
                        if (response.status === 'success') {
                            window.location.reload();
                        } else {
                            Swal.fire('Error', response.message, 'error');
                        }
                    },
                    error: function () {
                        Swal.fire('Error', 'Error combining carts. Please try again.', 'error');
                    }
                });
            }
        });
    });

    // Handle copy to live cart button click
    $('#copyToLiveCartBtn').on('click', function () {
        Swal.fire({
            title: 'Copy to Live Cart',
            text: 'The selected carts will be copied to your Live Cart.',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes, copy it!'
        }).then((result) => {
            if (result.isConfirmed) {
                var selectedCarts = $('.cartCheckbox:checked').map(function () {
                    return $(this).val();
                }).get();

                $.ajax({
                    url: 'https://checkout.nalpac.com/quick-order/copy-to-live-cart?sales_rep_id=' + sales_rep_id + '&customer_id=' + customer_id + '&contact_id=' + contact_id + '&shopify_customer_id=' + shopify_customer_id + '&contact_name=' + contact_name + '&hmac=' + hmac,
                    method: 'POST',
                    data: { cart_ids: selectedCarts },
                    success: function (response) {
                        if (response.status === 'success') {
                            Swal.fire('Copied!', 'Your selected carts have been copied to the live cart.', 'success');
                        } else {
                            Swal.fire('Error', response.message, 'error');
                        }
                    },
                    error: function () {
                        Swal.fire('Error', 'Error copying to live cart. Please try again.', 'error');
                    }
                });
            }
        });
    });

    // Handle delete carts button click
    $('#deleteCartsBtn').on('click', function () {
        Swal.fire({
            title: 'Delete Carts',
            text: 'Are you sure you want to delete the selected carts?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes, delete it!'
        }).then((result) => {
            if (result.isConfirmed) {
                var selectedCarts = $('.cartCheckbox:checked').map(function () {
                    return $(this).val();
                }).get();

                $.ajax({
                    url: 'https://checkout.nalpac.com/quick-order/delete-carts?sales_rep_id=' + sales_rep_id + '&customer_id=' + customer_id + '&contact_id=' + contact_id + '&shopify_customer_id=' + shopify_customer_id + '&contact_name=' + contact_name + '&hmac=' + hmac,
                    method: 'POST',
                    data: { cart_ids: selectedCarts },
                    success: function (response) {
                        if (response.status === 'success') {
                            selectedCarts.forEach(function (cartId) {
                                $('tr[data-cart-id="' + cartId + '"]').remove();
                            });

                            // If no carts left, reload the page
                            if ($('.cartCheckbox').length === 0) {
                                window.location.reload();
                            }
                        } else {
                            Swal.fire('Error', response.message, 'error');
                        }
                    },
                    error: function () {
                        Swal.fire('Error', 'Error deleting carts. Please try again.', 'error');
                    }
                });
            }
        });
    });

    $(document).on('click', '.shareCartBtn', function () {
        var cartId = $(this).data('cart-id');
        var shareToken = btoa(cartId).replace(/=+$/, ''); // Base64 encode and remove padding
        var shareUrl = 'https://www.nalpac.com/pages/retail-quick-order?share=' + shareToken;

        Swal.fire({
            title: 'Share Cart',
            html: '<p>Copy the link below to share this cart:</p><input type="text" id="shareCartLink" class="swal2-input" value="' + shareUrl + '" readonly>',
            showCancelButton: true,
            confirmButtonText: 'Copy Link',
            cancelButtonText: 'Close',
            focusConfirm: false,
            preConfirm: () => {
                const shareCartLink = Swal.getPopup().querySelector('#shareCartLink');
                shareCartLink.select();
                document.execCommand('copy');
                Swal.showValidationMessage('Link copied to clipboard');
            }
        });
    });


    // Function to fetch saved carts
    function fetchSavedCarts() {
        $.ajax({
            url: 'https://checkout.nalpac.com/quick-order/saved-carts?sales_rep_id=' + sales_rep_id + '&customer_id=' + customer_id + '&contact_id=' + contact_id + '&shopify_customer_id=' + shopify_customer_id + '&contact_name=' + contact_name + '&hmac=' + hmac,
            method: 'GET',
            success: function (response) {
                var rows = '';
                if (response.length > 0) {
                    response.forEach(function (cart) {
                        rows += '<tr data-cart-id="' + cart.id + '">' +
                            '<td><input type="checkbox" class="cartCheckbox" value="' + cart.id + '" data-cart-name="' + cart.cart_name + '"></td>' +
                            '<td><a href="/pages/retail-quick-order?cart_id=' + cart.id + '">' + cart.cart_name + '</a></td>' +
                            '<td class="acenter">' + cart.item_count + '</td>' +
                            '<td class="acenter">' + cart.line_item_count + '</td>' +
                            '<td>' + formatDate(cart.timestamp) + '</td>' +
                            '<td><button type="button" class="btn btn-link shareCartBtn" data-cart-id="' + cart.id + '"><i class="fas fa-share-alt"></i></button></td>' +
                            '</tr>';
                    });
                } else {
                    rows = '<tr><td colspan="6" class="text-center">No saved carts found.</td></tr>';
                }

                $('#savedCartsTableBody').html(rows);
            },
            error: function () {
                $('#savedCartsTableBody').html('<tr><td colspan="6" class="text-center">Error loading saved carts. Please try again.</td></tr>');
            }
        });
    }

    // Function to toggle cart actions based on selection
    function toggleCartActions() {
        var selectedCarts = $('.cartCheckbox:checked').length;
        if (selectedCarts > 0) {
            $('#cartActions').show();
            if (selectedCarts > 1) {
                $('#combineCartsBtn').show();
            } else {
                $('#combineCartsBtn').hide();
            }
            $('#copyToLiveCartBtn').show();
            $('#deleteCartsBtn').show();
        } else {
            $('#cartActions').hide();
            $('#combineCartsBtn').hide();
            $('#copyToLiveCartBtn').hide();
            $('#deleteCartsBtn').hide();
        }
    }

    // Function to format date
    function formatDate(dateString) {
        var options = { year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric', hour12: true };
        return new Date(dateString).toLocaleString('en-US', options);
    }
});